export const SHOW_INACCURATE_WARNING = 'show_inaccurate_data_warning'
export const VIDEO_INSERTION_TOOL_BANNER = 'video_insertion_tool_banner'
export const FLOWTAG_DEFAULT_CRM = 'flowtag_default_crm'
export const PRINT_STORE_SHOPPING_CART = 'print_store_shopping_cart'
export const PRINT_STORE_DISCOUNT_UPSELL = 'print_store_discount_upsell'
export const FLOWLYTICS_TOP_METRICS_ALL_TIME_OPTION = 'flowlytics_top_metrics_all_time_option'
export const QUICKER_DELIVERY = 'quicker_delivery'
export const ACTIVATION_PAGE_V1 = 'activation_activation_page_v1'
